﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Abonnement",
  "change": "Endre",
  "currency": "USD",
  "save": "Spar",
  "save17Percent": "<strong>Spar {{percent}} %</strong> med et årlig abonnement",
  "save17PercentNoBold": "Spar {{percent}} %",
  "yearly": "Årlig",
  "monthly": "Månedlig",
  "Lifetime": "Evigvarende",
  "PerMonth": "Per måned",
  "PerYear": "Per år",
  "Free": "Gratis",
  "optional": "valgfritt",
  "trialLengthTrial": "<0>{{ trialLength }}</0>-dagers prøveperiode",
  "viewAllPlans": "Se alle abonnementer",
  "myBoardmaker": "My Boardmaker",
  "canada": "Canada",
  "unitedStates": "USA",
  "oneMomentPlease": "Et øyeblikk …",
  "software": "Programvare",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Fullført",
  "loadingRegions": "Laster tilgjengelige regioner",
  "loadingPartners": "Laster tilgjengelige partnere",
  "supportedPeripherals": "Støttede eksterne enheter",
  "pleaseWait": "Vennligst vent …",
  "minimum": "Minimum",
  "recommended": "Anbefalt",
  "browser": "Nettleser",
  "tobiiDynavoxEyeTrackers": "Tobii Dynavox Eye Trackers",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "trenger hjelp til å velge",
  "or": "eller",
  "advantages": "Fordeler",
  "visitPartnerSite": "Gå til partnernettside",
  "recentOrders": "Nylige bestillinger",
  "current": "gjeldende",
  "orLater": "eller senere",
  "customerSupport": "kundestøtte",
  "proratedAmount": "Pro rata-beløp",
  "community": {
    "community": "Community",
    "getStartedNow": "Kom i gang nå!"
  },
  "personal": "Personlig abonnement",
  "professional": "Profesjonelt abonnement",
  "planCard": {
    "noCCRequired": "Kredittkort kreves ikke",
    "cCOnly": "Kun kredittkort",
    "cCOrPO": "Kredittkort eller innkjøpsordre",
    "myPlan": "Mitt abonnement",
    "currentPlan": "Gjeldende abonnement",
    "downgradeNotice": "Endringen trer i kraft når det gjeldende abonnementet utløper.",
    "upgradeNotice": "Endringen trer i kraft umiddelbart."
  },
  "selectedPlanSummary": {
    "summary": "Oppsummering",
    "change": "$t(change)",
    "subtotal": "Subtotal"
  },
  "action": {
    "joinToday": "Bli med i dag!",
    "finish": "Fullfør",
    "subscribe": "Abonnér",
    "resubscribe": "Abonnér igjen",
    "requestAQuote": "Be om tilbud",
    "try": "Prøv",
    "startTrial": "Start prøveperiode",
    "buyNow": "Kjøp nå",
    "tryIt": "Prøv det",
    "tryItFree": "Prøv det gratis i 30 dager!",
    "free": "gratis",
    "getStarted": "Kom i gang",
    "forTrialDays": "i <1>{{trialLength}}</1> dager",
    "comparePlans": "Sammenlign produkter",
    "hideComparisons": "Skjul sammenlign produkter",
    "learnMore": "Finn ut mer",
    "start": "Start",
    "next": "Neste",
    "edit": "Rediger",
    "cancel": "Avbryt",
    "imTaxExempt": "Skattefritak",
    "submit": "Send inn",
    "print": "Skriv ut",
    "backToPaymentDetails": "Tilbake til betalingsdetaljer",
    "close": "Lukk",
    "back": "Bakside",
    "continue": "Fortsett",
    "uploading": "Laster opp",
    "delete": "Slett",
    "update": "Oppdater",
    "generatingInvoice": "Genererer faktura",
    "proceed": "Gå videre",
    "modify": "Endre",
    "yes": "Ja",
    "signUp": "Registrer",
    "downloads": "Nedlasting"
  },
  "status": {
    "loading": "Laster …",
    "creatingAccount": "Oppretter konto …",
    "submitting": "Sender inn …",
    "submittingPayment": "Sender inn betaling …",
    "submittingRequest": "Sender inn forespørsel …"
  },
  "planComparison": {
    "label": "Hva er fordelene ved de ulike abonnementene?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Sammenligning av funksjoner",
    "subheader": "Verdens favorittløsning for å lage uendelig med symbolbasert kommunikasjon og visuelle støtter!"
  },
  "account": {
    "email": "E-post",
    "accountFoundTitle": "Konto funnet",
    "accountFoundMessage": "En konto med denne e-posten eksisterer allerede. Vil du logge inn med den kontoen, eller vil du bruke en annen e-post og opprette en ny konto?",
    "signedOutElsewhereTitle": "Du er blitt logget ut",
    "signedOutElsewhereMessage": "Du ble logget ut i en annen fane. Logg inn på nytt for å fortsette, eller lukk dette for å fortsette å surfe uten en konto.",
    "signedOutElsewhereDismiss": "Fortsett å surfe",
    "federatedEmailTitle": "Organisasjons-e-post gjenkjent",
    "federatedEmailMessage": "Denne e-postadressen bruker organisasjonens pålogging. Logg inn for å få tilgang til Boardmaker via organisasjonen din, eller bruk en annen e-postadresse for å opprette en ny konto.",
    "federatedEmailUseDifferent": "Bruk en annen e-postadresse",
    "logIn": "Logg inn",
    "logOut": "Logg av",
    "loggingIn": "Logger inn …",
    "loggingOut": "Logger av …",
    "verifying": "Verifiserer …",
    "loggingInMessage": "Logger deg inn …",
    "createAccount": "Opprett konto",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Har allerede en ",
    "login2": "Tobii Dynavox",
    "login3": "-konto",
    "loginPrompt": "Har du allerede en <1>Tobii Dynavox-konto</1>? <3>Logg inn</3>",
    "cancelSubscription": "Avbryt abonnement",
    "areYouSure": "Er du sikker på at du vil velge dette abonnementet? Å fortsette vil gjøre det følgende:",
    "cancelSubscriptionProcess": "Avbryte abonnementsprosessen (nåværende fremgang vil gå tapt)",
    "changeToCommunityPlan": "Endre kontoen din til et Community-abonnement",
    "onceYouveCompletedYourProfile": "Når du har fullført profilen din kan du når som helst oppgradere abonnementet ditt fra Min konto-delen, dersom du ønsker det.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Henter brukerinformasjon"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Vennligst fyll ut detaljene nedenfor, så vil en kundeansvarlig ta kontakt med deg om kort tid.",
    "fillOutDetailsBelowLicense": "Vennligst fyll ut detaljene nedenfor, så vil en salgskonsulent ta kontakt med deg om kort tid."
  },
  "forms": {
    "confirmEmail": "Bekreft e-post",
    "billingDetails": "Faktureringsdetaljer",
    "paymentType": "Betalingstype",
    "creditCardType": "Betalingstype",
    "creditCard": "Kredittkort",
    "purchaseOrder": "Innkjøpsordre",
    "cardNumber": "Kortnummer",
    "expirationDate": "Utløpsdato",
    "cardholderName": "Kortholders navn",
    "cardSecurityCode": "Kortets sikkerhetskode",
    "securityCode": "Sikkerhetskode",
    "organizationName": "Organisasjonsnavn",
    "accountsPayableEmail": "Kontobetalers e-post",
    "firstName": "Fornavn",
    "lastName": "Etternavn",
    "addressLine": "Adresselinje 1",
    "addressLine2": "Adresselinje 2",
    "country": "Land",
    "language": "Språk",
    "city": "By",
    "stateProvinceRegion": "Delstat/provins/region",
    "zipPostalCode": "Postnummer",
    "month": "Måned",
    "year": "År",
    "optional": "valgfritt",
    "username": "Brukernavn",
    "name": "Navn",
    "phoneNumber": "Telefonnummer",
    "phone": "Telefon",
    "email": "E-post",
    "url": "URL",
    "selectYourCountry": "Velg ditt land",
    "selectYourState": "Velg din delstat",
    "selectYourProvinceTerritory": "Velg din provins eller ditt territorium",
    "selectYourTerm": "Velg termin",
    "1year": "1 år",
    "2years": "2 år",
    "3years": "3 år",
    "4years": "4 år",
    "5years": "5 år",
    "instructorLogins": "Antall innlogginger for instruktører",
    "studentLogins": "Antall innlogginger for elever",
    "term": "Termin",
    "tradeIn": "Er du kvalifisert for en bytterabatt?",
    "legacyVersions": "Har du eldre versjoner av Boardmaker som du kan bytte inn mot en rabatt på prisen av myBoardmaker?",
    "selectAResponse": "Velg et svar",
    "yes": "Ja",
    "no": "Nei",
    "notSure": "Ikke sikker",
    "password": "Passord",
    "confirmPassword": "Bekreft passord",
    "additionalInformationOrQuestions": "Ytterligere informasjon eller spørsmål",
    "countryNotSupported": "---",
    "uploadDocument": "Last opp dokument",
    "chooseFile": "Velg fil",
    "paymentMethod": "Betalingsmetode",
    "purchaseOrdersAreOnlyProcessed": "Innkjøpsordre behandles kun idet ordren sendes inn, så de kan endres når som helst før det.",
    "PONumber": "Innkjøpsordrenummer",
    "PONotes": "Organisasjonsnotater",
    "iVerifyThatImAuthorized": "Jeg bekrefter at jeg har autorisasjonen til å sende inn denne innkjøpsordren.",
    "submissionSuccessful": "Innsendingen var vellykket!",
    "thankYourForYourRequest": "Takk for forespørselen! En kundeansvarlig vil ta kontakt med deg om kort tid.",
    "ccExpDateFormat": "MM/YYYY",
    "numberOfLicenses": "Antall lisenser",
    "pleaseEnterYourName": "Skriv inn navnet ditt nøyaktig slik det vises på kortet",
    "needHelpFindingSecurityCode": "Trenger du hjelp til å finne kortets sikkerhetskode?"
  },
  "validation": {
    "required": "Obligatorisk",
    "invalidEmail": "Ugyldig e-post",
    "emailsMustMatch": "E-postadressene må være like",
    "passwordsMustMatch": "Passordene må være like",
    "errorOccurred": "Det oppsto en feil ved innsending av skjemaet",
    "tryAgain": "Prøv igjen. Kontakt kundestøtte hvis problemet vedvarer.",
    "errorOccurredPDF": "Det oppstod en feil ved lasting av faktura-PDF",
    "password": {
      "minLength": "Passordet må være på minst 8 tegn",
      "tooShort": "For kort",
      "checking": "Sjekker …"
    },
    "USZipCode": "Må oppgi et amerikansk postnummer (zip)",
    "CAZipCode": "Må oppgi et canadisk postnummer.",
    "invalidCardNumber": "Ugyldig kortnummer",
    "invalidCardType": "Ugyldig korttype",
    "invalidExpirationDate": "Ugyldig utløpsdato",
    "invalidSecurityCode": "Ugyldig sikkerhetskode",
    "securityCodeNumericWarning": "Sikkerhetskoden kan kun bestå av tall",
    "invalidUsernameWarning": "Ugyldig brukernavn. Kan kun bestå av bokstaver og tall.",
    "usernameMaxLengthWarning": "Brukernavn kan ikke være lenger enn 60 tegn",
    "badZip": "Det angitte postnummeret er ikke gyldig for den valgte delstaten.",
    "badPostalCode": "Det angitte postnummeret er ikke gyldig for den valgte provinsen eller territoriet.",
    "canadianAddressNeedsCad": "Kanadiske fakturaadresser faktureres i kanadiske dollar. Velg flagget øverst på siden og deretter Canada for å fortsette."
  },
  "invoice": {
    "communityHeader": "Ingen kredittkort. Bare gratis tilgang til myBoardmaker Community. Behold dataene og fremgangen din dersom du senere oppgraderer til et betalt abonnement. Hva venter du på?",
    "trialHeader": "Ingen begrensninger. Ingen kredittkort. Behold dataene og fremgangen din dersom du senere konverterer prøveperioden din til et betalt abonnement. Hva venter du på?",
    "plan": "Abonnement",
    "term": "Termin",
    "price": "Pris",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Betalingsdetaljer",
    "endingWith": "Slutter på",
    "expires": "Utløper",
    "orderSummary": "Ordresammendrag",
    "orderDate": "Ordredato",
    "orderNumber": "Ordrenummer",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Skatt",
    "total": "Total",
    "aConfirmationEmail": "En ordrebekreftelse har blitt sendt på e-post til",
    "printOrderSummary": "Skriv ut ordrebekreftelse",
    "recurringPaymentDisclaimer": "Ordren din inkluderer en <strong>gjentakende betaling</strong> på <3>{{amount}}</3> som fornyes <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Vi belaster deg <strong>{{amount}}</strong> <strong>{{date}}</strong>, når det nye abonnementet ditt starter.",
    "PODisclaimer": "Abonnementet ditt er nå aktivt og klart til bruk. For å unngå avbrytelser i tjenesten må vi motta betalingen din innen <strong>30 dager</strong>. Dersom betalingen ikke er mottatt innen <4>{{date, LL}}</4> vil kontoen din bli gjort om til en gratis Community-konto frem til det utestående er betalt.",
    "purchaseOrderNumber": "Innkjøpsordrenummer",
    "orgNotes": "Organisasjonsnotater",
    "pleaseSendACopyOfYourInvoice": "Send betalingen og en kopi av fakturaen til:",
    "ifYourPurchaseOrdersReady": "Dersom innkjøpsordren din er klar, kan du laste den opp nå.",
    "supportedFileTypes": "Støttede filtyper: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Når den tid kommer, sender vi en e-post til <1>{{email}}</1> for å minne deg om neste betalingsfrist.",
    "uploadSuccessful": "Opplastingen var vellykket",
    "yourAccountWillContinue": "Takk for din innkjøpsordre. For fornying av abonnementer kan det ta opptil 14 dager før ordren din er behandlet. Når den er fullført vil du motta en e-post som bekrefter fullføringen, og som inneholder fakturaen din.",
    "billing": "Fakturaadresse",
    "payment": "Betalingsmetode",
    "ifYourPurchaseOrderIsReady": "Dersom innkjøpsordren din er klar, kan du laste den opp nå.",
    "PODisclaimer1": "Abonnementet ditt er nå aktivt og klart til bruk.",
    "PODisclaimer2": "Betalingen må være mottatt innen 30 dager, ellers vil kontoen din automatisk gjøres om til en gratis Community-konto.",
    "POStartsLaterDisclaimer": "Vi sender fakturaen din <strong>{{date}}</strong>, når det nye abonnementet ditt starter. Betalingen forfaller innen 30 dager fra den datoen."
  },
  "legal": {
    "privacyPolicy": "Retningslinjer for personvern",
    "studentPolicy": "Retningslinjer for behandling av studentdata",
    "termsAndConditions": "Vilkår og betingelser",
    "termsOfService": "Tjenestevilkår",
    "tdTermsAndConditions": "Jeg godtar Tobii Dynavox’ <1>$t(legal.termsAndConditions)</1>",
    "contactUs": "Kontakt oss"
  },
  "errors": {
    "error": "Feil",
    "loadingPlans": "Laster inn produkter",
    "sorry": "Beklager … det er ikke deg … det er oss",
    "somethingWentWrong": "Noe gikk galt hos oss. Vi har registrert feilen, og oppfordrer deg til å <1>{{link}}</1> hvis du opplever dette problemet igjen.",
    "tryGoingBack": "Forsøk å gå tilbake eller <1>{{link}}</1>",
    "downloadList": "Kunne ikke laste inn nedlastingslisten."
  },
  "404": {
    "sorry": "Beklager … vi kan ikke finne den siden",
    "oldLink": "Koblingen kan være gammel, eller den kan ha blitt flyttet.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Start en gratis prøveperiode nå!",
    "startYourFreeTrial": "Start din gratis prøveperiode",
    "todayWhichIncludesAccessForThirtyDays": " i dag, med tilgang i 30 dager!"
  },
  "navigation": {
    "bmoRedirect": "Omdirigerer deg til myBoardmaker …"
  },
  "expired": {
    "expiredTrialText": "Vi håper du likte den 30-dagers ubegrensede smakebiten. Prøveperioden din har blitt omgjort til en gratis Community-konto, og fremgangen og alle dataene dine* har blitt lagret. For å få tilgang til premiumfunksjoner i løpet av prøveperioden, oppgraderer du bare til et månedlig eller årlig abonnement.",
    "dataAndProgress": "* Data og fremgang i premiumfunksjoner er kun tilgjengelige med et helhetlig, betalt abonnement."
  },
  "currencySelector": {
    "header": "Velg ditt land og språk",
    "disclaimer": {
      "USD": "Velg USA dersom landet ditt ikke er på listen."
    }
  },
  "taxExempt": {
    "us&ca": "Kun for USA og Canada",
    "taxExemptionProgram": "Send inn skattefritak-dokumentene dine ved hjelp av dette skjemaet. Vi kontakter deg på e-post innen tre virkedager for å bekrefte din skattefritak-status. Etter at du har mottatt bekreftelses-e-posten kan du legge inn en ordre uten skatt. Dersom du legger inn en ordre før du har mottatt bekreftelses-e-posten vil du bli belastet for ikke-refunderbar skatt.",
    "taxExemptionProgramExisting": "Send inn skattefritak-dokumentene dine ved hjelp av dette skjemaet. Vi kontakter deg på e-post innen tre virkedager for å bekrefte din skattefritak-status. Etter at du har mottatt godkjennings-e-posten vil fremtidige kjøp og abonnementsfornyelser ikke bli pålagt skatt. Skatt på kjøp gjennomført før mottak av godkjennings-e-posten om skattefritak er ikke refunderbare.",
    "yourSubmissionWasSuccessfulNew": "Innsendingen var vellykket. Våre ansatte kommer til å gjennomgå dokumentasjonen, og du bør motta en e-post innen tre virkedager med en bekreftelse på at søknaden din har blitt behandlet. Når søknaden er godkjent kan du fullføre ordren din skattefritt. I mellomtiden har vi opprettet en gratis Community-konto for deg, slik at du kan begynne å utforske alt det myBoardmaker kan tilby.",
    "yourSubmissionWasSuccessfulExisting": "Innsendingen var vellykket. Våre ansatte kommer til å gjennomgå dokumentasjonen, og du bør motta en e-post innen tre virkedager med en bekreftelse på at søknaden din har blitt behandlet. Når søknaden er godkjent kan du fullføre neste betaling skattefritt."
  },
  "modify": {
    "contactCustomerSupport": "Kontakt <1>{{supportLink}}</1> for å endre abonnementet ditt",
    "billingDetails": "Endre faktureringsdetaljer",
    "paymentModalHeader": "Oppdateringen var vellykket!",
    "paymentModalBody": "Endringene dine vil gjenspeiles i neste faktureringssyklus.",
    "thankYou": "Takk for din betaling!",
    "daysRemaining": "dager gjenstår",
    "dueDisclaimer": "Dersom betalingen ikke mottas innen 30 dager etter fornyelsesdatoen, vil kontoen din automatisk gjøres om til en gratis Community-konto frem til det utestående er betalt.",
    "lateDisclaimer": "Vennligst betal det utestående beløpet i sin helhet for å unngå avbrytelser i abonnementet ditt. Dersom vi ikke mottar betaling vil kontoen din automatisk gjøres om til en gratis Community-konto frem til det utestående er betalt.",
    "nextPaymentDueIn": "Neste betaling forfaller om",
    "days": "dager",
    "paymentIs": "Betalingen forfalt for",
    "daysPastDue": "dager siden",
    "recurringPaymentDisclaimer": "Din/ditt <1>planOrOrder</1> inkluderer en <strong>gjentakende betaling</strong> på <4>{{amount}}</4> som fornyes <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Abonnementet ditt inkluderer en <strong>gjentakende betaling</strong> som fornyes <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Du kan sende inn innkjøpsordren ved hjelp av én av metodene beskrevet nedenfor. Ta kontakt med kundestøtte-teamet vårt for å aktivere abonnementet ditt igjen.",
    "yourAccountHasBeenConverted": "Den betalte kontoen din konverteres til en gratis Community-konto",
    "balanceDueIn": "Beløp som forfaller om",
    "subscriptionExpiresIn": "Abonnement utløper om",
    "paymentPastDue": "Betaling forfalt",
    "autoRenewal": "Automatisk fornyelse",
    "turnAutoRenewOff": {
      "header": "Deaktiver automatisk fornyelse av abonnement",
      "areYouSure": "Er du sikker på at du vil slå av automatisk fornyelse? Å fortsette vil gjøre det følgende:",
      "points": [
        "Avslutt det betalte abonnementet ditt ved slutten av gjeldende faktureringssyklus.",
        "Gjør om kontoen din til en gratis Community-konto ved slutten av gjeldende faktureringssyklus.",
        "Du har tilgang til innholdet ditt etter omgjøringen, og du kan når som helst abonnere igjen for å få tilgang til premiumfunksjonene som følger med de betalte abonnementene. ",
        "Hvis du ombestemmer deg før det gjeldende abonnementet går ut kan du bare slå på automatisk fornyelse igjen."
      ],
      "footer": "Vil du deaktivere automatisk fornyelse?"
    },
    "turnAutoRenewOn": {
      "header": "Aktiver automatisk fornyelse av abonnement",
      "areYouSure": "Funksjoner ved automatisk fornyelse av abonnement:",
      "points": [
        "Abonnementet ditt fornyes automatisk når den gjeldende abonnementsperioden slutter.",
        "Enkel betaling ved bruk av din lagrede betalingsmetode.",
        "Vi sender deg en kvittering på e-post hver gang abonnementet ditt fornyes.",
        "Du kan alltids endre abonnementsinnstillingene dine under Mine abonnementsdetaljer.",
        "Har du ombestemt deg? Deaktiver automatisk fornyelse før utgangen av den siste dagen i gjeldende abonnementsperiode, så blir du ikke fakturert."
      ],
      "footer": "Vil du aktivere automatisk fornyelse?"
    },
    "on": "På",
    "off": "Av",
    "pending": "venter",
    "plan": "Abonnement",
    "term": "Termin",
    "effective": "Effektiv",
    "subscription": "Abonnement",
    "downgradeWarning": {
      "title": "Nedgrader abonnement",
      "prompt": "Er du sikker på at du vil velge dette abonnementet? Å fortsette vil gjøre det følgende:",
      "planChange": "Nedgrader abonnementet ditt fra Profesjonelt til Personlig ved slutten av gjeldende faktureringssyklus.",
      "termChange": "Nedgrader abonnementet ditt fra årlig til månedlig ved slutten av gjeldende faktureringssyklus.",
      "changeNote": "Endringene dine vil gjenspeiles i neste faktureringssyklus.",
      "termChangeMultiToYearly": "Nedgrader fra flerårig termin til årlig termin ved slutten av gjeldende faktureringssyklus.",
      "termChangeMultiToMonthly": "Nedgrader abonnementet fra flerårig termin til månedlig termin ved slutten av gjeldende faktureringssyklus."
    },
    "futureAmendmentThankYou": "Disse endringene vil tre i kraft ved slutten av gjeldende faktureringssyklus. En faktura blir tilgjengelig når disse endringene er iverksatt på kontoen din. Ring <1>kundestøtte</1> dersom du ønsker å avbryte en ventende endring.",
    "futureAmendmentDisclaimer": "Ditt gjeldende <1>{{planName}}</1>-abonnement utløper <3>{{startEndDate}}</3>. Ditt nye <5>{{selectedPlanName}}</5>-abonnement starter <7>{{startEndDate}}</7> og fornyes automatisk <9>{{term}}</9>.",
    "modificationPending": "Abonnementsendring venter",
    "paymentDeclined": "Fornyelsestransaksjonen for abonnementet ditt ble avvist. Endre betalingsmetoden din innen <1>{{date}}</1>, ellers vil abonnementet ditt bli avsluttet.",
    "continueSubscription": "Abonnementet ditt avsluttes <1>{{ date1 }}</1>. Hvis du ønsker å forlenge abonnementet ditt i ytterligere {{term}}, kan du slå på automatisk fornyelse innen <5>{{ date2 }}</5>, så behandler vi betalingen din den påfølgende dagen.",
    "discontinuedRatePlan": "Det gjeldende abonnementsproduktet er ikke lenger tilgjengelig. Vennligst velg et annet alternativ.",
    "cancelYourSubscription": "Dersom du ønsker å avslutte abonnementet ditt og motta full refusjon, må du kontakte <1>{{supportLink}}</1> før <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Endre abonnement",
    "cancelCardText": "Du kan avbryte abonnementet ditt når som helst. Men vi vil gjerne at du blir.",
    "cancelConfirmTitle": "Er du sikker på at du vil avbryte abonnementet ditt?",
    "cancelConfirmIntro": "Ditt nåværende abonnement forblir aktivt til <strong>{{date}}</strong>. Når abonnementet ditt utløper:",
    "cancelConsequences": [
      "Du mister tilgangen til premiumfunksjoner.",
      "Du går glipp av eksklusive fordeler som følger med abonnementet ditt.",
      "Fordelene ved abonnementet ditt opphører når det nåværende abonnementet utløper."
    ],
    "keepSubscription": "Behold abonnementet mitt",
    "confirmCancel": "Nei, jeg vil avbryte",
    "cancelledTitle": "Abonnementet ditt er avbrutt!",
    "cancelledBody": "Abonnementet ditt er avbrutt. Du har ikke tilgang til premiumkontoen din etter {{date}}.",
    "cancelledFarewell": "Vi er lei oss for at du forlater oss! Du er alltid velkommen tilbake.",
    "done": "Ferdig",
    "cancelledNotice": "Ditt nåværende <strong>{{planName}}</strong>-abonnement utløper <strong>{{date}}</strong>. Forny abonnementet ditt for å fortsette å nyte godt av premiumfunksjonene våre.",
    "resubscribedNotice": "Det nye <strong>{{planName}}</strong>-abonnementet ditt starter <strong>{{date}}</strong>, når det nåværende utløper."
  },
  "tdAccount": {
    "title": "Tobii Dynavox-konto",
    "header": "Hva er en Tobii Dynavox engangsinnloggings-konto (SSO)?",
    "body": "Din Tobii Dynavox SSO-konto består av en e-postadresse og et passord, og er den ene kontoen du trenger for å logge deg inn på alle våre nettsider og apper. I tillegg til forbedrede sikkerhetsfordeler, gir SSO raskere og enklere tilgang til innholdet ditt i alle Tobii Dynavox-tjenester.",
    "haveA": "Har du en",
    "tobiiDynavoxAccount": "Tobii Dynavox-konto?"
  },
  "redirectPageTitle": {
    "homePage": "Hjemmeside",
    "profileCreation": "Profiloppretting"
  },
  "download": {
    "downloadBoardmaker": "Last ned Boardmaker",
    "downloadBoardmakerStudentCenter": "Last ned Boardmaker Student Center",
    "downloadOtherVersions": "Last ned andre versjoner",
    "downloadBoardmakerStudio": "Last ned Boardmaker Studio",
    "licenseKey": "Lisensnøkkel",
    "download": "Last ned",
    "licenseHelper": "Administrering av lisens",
    "discontinued": "Avviklet <1>{{discontinueDate}}</1>. Se <3>systemkrav</3>.",
    "mainFeatures": "Hovedfunksjoner",
    "compatibility": "Kompatibilitet",
    "improvements": "Forbedringer",
    "bugFixes": "Feilrettinger",
    "version": "Versjon", 
    "discontinuedSupport": "Støttes ikke lenger",
    "releaseDate": "Utgitt {{date}}",
    "discontinuedDate": "Avviklet {{date}}",
    "boardmakerSummary": "Velg knappen nedenfor for å laste ned den siste versjonen av Boardmaker Editor – som brukes for å lage og redigere aktiviteter.  Installeringen fungerer for alle kontotyper og alle støttede språk.",
    "studentCenterSummary": "Velg knappen nedenfor for å laste ned den siste versjonen av Boardmaker Student Center –  som brukes for å spille Boardmaker-aktiviteter. Installeringen fungerer for alle kontotyper og alle støttede språk.",
    "boardmakerIntro": "Boardmaker 7 Editor er et førsteklasses verktøyet som hjelper lærere, terapeuter og foreldre med å lage, redigere og dele Boardmaker-aktiviteter.  Støtter læring og kommunikasjon i klasserommet, terapirommet eller hjemmet med massevis av materiell som kan tilpasses.",
"studentCenterIntro": "Når det brukes sammen med visse typer Boardmaker 7-abonnementer, kan lærerne tilordne aktiviteter til studenter i Boardmaker 7 Student Center-appen og følge fremgangen deres.  Studentene kan bruke appe for å fullføre aktivitetene enten hjemme eller på skolen.",
"boardmakerStudioIntro": "Boardmaker Studio gjør det mulig å opprette og redigere aktiviteter for personer som hjelper elever med nedsatte funksjonsevner med å lære og kommunisere ved hjelp av symboler, tekst og syntetisk og innspilt tale.",
"mobilePlayerIntro": "Når det brukes sammen med visse typer myBoardmaker-abonnementer, kan lærerne tilordne aktiviteter til studenter i Boardmaker Student Center-appen og følge fremgangen deres.  Studentene kan bruke appe for å fullføre aktivitetene enten hjemme eller på skolen.",
    "communityStartHeader": ["Få tilgang til Community og lagring", 0, 0],
    "communityStartBody": [
      "Boardmaker er designet for å fungere med Boardmakeronline.com, der du trygt kan sikkerhetskopiere de personlige Boardmaker-filene dine og få tilgang til vårt globale Community. Community-medlemmer kan dele det de har laget, og finne nye Boardmaker-aktiviteter fra andre brukere. Registrer deg for en gratis Community-konto for å få tilgang!",
      0,
      0
    ],
    "latestMobile": "For den beste mulige opplevelse, prøv å laste ned programvaren fra en enhet som møter <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "systemkrav",
    "viewSystemRequirements": "Vis <1>{{guideLink}}</1> for systemkrav.",
    "onThisPage": "På denne siden",
    "communityStart": {
      "header": "Få tilgang til Community og lagring",
      "body": "Boardmaker er utformet for å fungere med myboardmaker.com Din gratis Community-konto inkluderer:",
      "pointOne": "Skylagring – trygg sikkerhetskopiering av dine personlige Boardmaker-filer, og tilgang til dem overalt!",
      "pointTwo": "Activities-to-Go – nivådelt, tematisk pensum som er klart for utskrift og bruk.",
      "pointThree": "Tilgang til vårt globale Community – del det du har laget, og finn nye Boardmaker-aktiviteter fra andre brukere.",
      "footer": "Registrer deg for en gratis Community-konto for å få tilgang!"
    },
    "BoardmakerCompatible": "Denne enheten er ikke kompatibel med Boardmaker-programvaren.",
    "BoardmakerStudentCenterCompatible": "Denne enheten er ikke kompatibel med applikasjonen Boardmaker Student Center.",
    "BoardmakerMobile": "Boardmaker-applikasjoner støttes ikke på denne enheten."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "abonnement",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "lisens",
      "tolicenseText": "engangskjøp",
      "mainText": "Foretrekker du et <1>{{ toggleText }}</1> eller et <3>{{ helpLink }}</3>?",
      "preferencedText": "Foretrekker du et "
    },
    "comparison": {
      "accessTo": "Tilgang til følgende …",
      "title": "Hjelp meg å velge",
      "titleDescription": "En rask titt på forskjellene mellom et myBoardmaker-abonnement og Boardmaker-programvaren alene.",
      "titles": {
        "investment": "Investering",
        "includedSoftware": "Inkludert programvare",
        "softwareUpdates": "Programvareoppdateringer",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Skylagring",
        "curriculum": "Pensum",
        "studentManagement": "Studentledelse"
      },
      "subscription": {
        "header": "Boardmaker Online-abonnement",
        "investment": "Lav oppstartskostnad, årlige eller månedlige betalingsalternativer",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Inkludert (2–3 ganger i året)",
        "pcsSymbols": "Alle symboler, inkludert nye symboler hver andre uke",
        "cloudStorage": ["Lagrede aktiviteter", "lagrede media"],
        "curriculum": [
          "Boardmaker Activities to Go – 10 temaer x 4 enheter hver",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": ["Tildel aktiviteter\u00B9", "følg måloppnåelse"]
      },
      "license": {
        "header": "Kun programvare",
        "investment": "Engangskjøp av programvare",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Betalte periodiske oppgraderinger (hvert 2–3. år)",
        "pcsSymbols": "Alle symboler som var tilgjengelig ved siste lansering (PCS-abonnement kommer snart)",
        "cloudStorage": "Lagrede aktiviteter",
        "curriculum": "Boardmaker Activities to Go – 1 tema x 4 enheter",
        "studentManagement": "Ingen"
      },
      "note": "Brukere kan administrere og legge til oppgaver for individuelle elever i det Profesjonelle abonnementet",
      "note2": "Kun tilgang via Student Center Player",
      "note3": "Brukere kan administrere og legge til oppgaver for individuelle elever i det Profesjonelle abonnementet",
      "localizationNoteOne": "Boardmaker 7-appene er tilgjengelig på følgende språk, både for abonnementsbrukere og brukere med engangskjøp (kun programvare)",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Engelsk (USA)",
        "Spansk",
        "Tysk",
        "Svensk",
        "Finsk",
        "Russisk",
        "Dansk",
        "Norsk",
        "Fransk",
        "Italiensk",
        "Polsk",
        "Portugisisk"
      ],
      "localizationNoteTwo": "Pensum og nettsiden myBoardmaker.com er kun tilgjengelig på engelsk."
    }
  },
  "systemRequirements": "Systemkrav",
  "releaseNotes": "Versjonsmerknader",
  "operatingSystem": {
    "title": "Operativsystem",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobil)",
    "windows": "Windows",
    "unknown": "Ukjent"
  },
  "perpetual": {
    "trial": {
      "intro": "Ingen kredittkort. Ingen forpliktelse. Bare <1>{{trialLength}}</1> dager med fortløpende, ubegrenset tilgang til vår nyeste Boardmaker-programvare. Etter du har lastet ned og installert programvaren på datamaskinen din, kan du forespørre en <3>{{trialLength}}</3>-dagers aktiveringsnøkkel<5>*</5> inne i programvaren.",
      "footnote": "<0>*</0>Prøveperioden begynner den dagen programvaren aktiveres, og den vil være aktiv i <2>{{trialLength}}</2> dager fortløpende.",
      "downloadFootnote": "<0>v{{version}}</0> inkluderer de nyeste funksjonene og feilrettingene. Se <2>systemkrav</2>."
    },
    "thankyou": {
      "intro": "Se etter ordrebekreftelses-e-posten din, som inneholder aktiveringsnøkkelen og nedlastingskoblinger for Boardmaker. Vi har også inkludert denne informasjonen nedenfor. Last ned og installer Boardmaker på datamaskinen din, og bruk deretter aktiveringsnøkkelen for å aktivere programvaren. Når den er aktivert vil du få ett år med gratis oppdateringer. <1>Husk å lagre aktiveringsnøkkelen din for fremtidig bruk.</1>"
    },
    "latest": "Nyeste",
    "legacy": "Eldre versjoner"
  },
  "countries": {
    "us": "USA"
  },
  "currencyChange": {
    "header": "Valutaendring",
    "body": "Per i dag kan ikke abonnementer kjøpes i valutaen fra ditt valgte land. Ved å gå videre blir valutaen endret til amerikanske dollar – USD."
  },
  "partner": {
    "body": "Den valgte partneren eller støtteleverandøren er din primærkontakt for alle produktrelaterte spørsmål og tekniske problemer.",
    "contactUs": "Dersom det angitte landet ikke stemmer, ta ",
    "contactCustomerService": "kontakt med kundestøtte."
  }
}
